var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 19C18.0752 19 23 13.8667 23 12C23 10.1333 18.0752 5 12.0001 5C5.92491 5 1 10.1333 1 12C1 13.8667 5.92491 19 12.0001 19Z",
    stroke: "#707173",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 16C14.2092 16 16 14.2091 16 12C16 9.79086 14.2092 8 12.0001 8C9.79093 8 8 9.79086 8 12C8 14.2091 9.79093 16 12.0001 16Z",
    stroke: "#707173",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.604d153ef4982b6db5b1b5e84121e4bf.svg";
export { ForwardRef as ReactComponent };